/** @jsxImportSource @emotion/react */
import { format } from 'date-fns'

import { findAllAiTestTrainingDataHistory_findAllAiTestTrainingDataHistory_items as TrainingStatus } from '__generatedTypes__/findAllAiTestTrainingDataHistory'
import { ReTrainingStatus } from '__generatedTypes__/globalTypes'
import Badge from 'components/Badge'
import Table from 'components/Table'
import Tooltip from 'components/Tooltip'
import { colors } from 'theme/colors'
import * as classes from './styles'

const STATUS_LABELS: Record<ReTrainingStatus, string> = {
  [ReTrainingStatus.Succeeded]: 'Completed',
  [ReTrainingStatus.Running]: 'In progress',
  [ReTrainingStatus.ValidatingFiles]: 'In progress',
  [ReTrainingStatus.Cancelled]: 'Cancelled',
  [ReTrainingStatus.Failed]: 'Failed',
  [ReTrainingStatus.Queued]: 'Queued',
}

const STATUS_COLORS: Record<ReTrainingStatus, string> = {
  [ReTrainingStatus.Succeeded]: colors.ethics,
  [ReTrainingStatus.Running]: colors.typographyThree,
  [ReTrainingStatus.ValidatingFiles]: colors.typographyThree,
  [ReTrainingStatus.Cancelled]: colors.organicChemistry,
  [ReTrainingStatus.Failed]: colors.quantitativeReasoning,
  [ReTrainingStatus.Queued]: colors.java,
}

type Props = {
  jobs: TrainingStatus[]
}

export const TrainingHistory = ({ jobs }: Props) => (
  <Table<TrainingStatus>
    css={classes.table}
    columns={[
      {
        title: 'Date',
        renderCell: (job) => format(new Date(job.createdAt), 'dd.MM.yyyy'),
      },
      {
        title: 'Status',
        renderCell: (job) => {
          const badge = (
            <Badge
              css={classes.badge}
              text={STATUS_LABELS[job.status]}
              color={STATUS_COLORS[job.status]}
              data-testid="job-status-badge"
            />
          )

          return job.status === ReTrainingStatus.Failed ? (
            <Tooltip css={classes.tooltip} title={job.errorMessage || 'Training failed'} arrow>
              {badge}
            </Tooltip>
          ) : (
            badge
          )
        },
      },
    ]}
    items={jobs}
  />
)
